// extracted by mini-css-extract-plugin
module.exports = {"addPhotoButton":"AddPhotoButton_addPhotoButton__zQFGr"};